/**
 * Shortens a blockchain address for display.
 * @param address The full address string.
 * @param startChars Number of characters to show at the start (default 4).
 * @param endChars Number of characters to show at the end (default 4).
 * @returns The shortened address string (e.g., "0x123...abcd") or the original if too short/invalid.
 */
export const shortenAddress = (address: string | null | undefined, startChars: number = 4, endChars: number = 4): string => {
    if (!address) {
        return "";
    }
    const totalChars = startChars + endChars;
    if (address.length <= totalChars) {
        return address; // Address is too short to shorten
    }
    return `${address.substring(0, startChars)}...${address.substring(address.length - endChars)}`;
};
